import { render } from "./paymentComponent.vue?vue&type=template&id=e8ee53ac"
import script from "./paymentComponent.vue?vue&type=script&lang=js"
export * from "./paymentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__